import React from 'react';
import classnames from 'classnames';

import {
  DUTY_TYPE,
  ELD_DRIVER_STATUS,
  EXCEPTION_STATUS,
  statusToString,
} from 'src/constants/ELDConstants';

import './statusButton.scss';

interface Props {
  active: boolean;
  exceptionStatus?: number;
  dutyType: DUTY_TYPE;
  dutySubtitle: string;
  onClick?: () => void;
}

export const StatusButton: React.FC<Props> = ({
  active,
  exceptionStatus,
  dutyType,
  dutySubtitle,
  onClick,
}) => {
  const statusButtonClassName = classnames(
    'status-button__button',
    active && {
      'status-button__button--off': dutyType === statusToString(ELD_DRIVER_STATUS.OFF),
      'status-button__button--sb': dutyType === statusToString(ELD_DRIVER_STATUS.SB),
      'status-button__button--on': dutyType === statusToString(ELD_DRIVER_STATUS.ON),
      'status-button__button--exception':
        exceptionStatus === EXCEPTION_STATUS.AD || exceptionStatus === EXCEPTION_STATUS.SH,
    },
  );

  return (
    <div className="status-button">
      <button onClick={onClick} className={statusButtonClassName}>
        {dutyType}
      </button>
      <div className="status-button__subtitle">{dutySubtitle}</div>
    </div>
  );
};
